import { countries } from 'countries-list';
import sortBy from 'lodash/sortBy';

const countryArray = [...sortBy(Object.values(countries), 'name')];
export default countryArray;
